import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    id: '',
    token: getToken(),
    username: '',
    name: '',
    full_name: '',
    avatar: '',
    roles: [],
    permissions: [],
    is_open_company: null,
    is_self_use: null,
    is_show_cost: null,
    cooperation_type: '',
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_ID: (state, id) => {
      state.id = id
    },
    SET_NAME: (state, username) => {
      state.username = username
    },
    SET_FULL_NAME: (state, full_name) => {
      state.full_name = full_name
    },
    SET_USER_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_IS_OPEN_COMPANY: (state, is_open_company) => {
      state.is_open_company = is_open_company
    },
    SET_IS_SELF_USE: (state, is_self_use) => {
      state.is_self_use = is_self_use
    },
    SET_IS_SHOW_COST: (state, is_show_cost) => {
      state.is_show_cost = is_show_cost
    },
    SET_COOPERATION_TYPE: (state, cooperation_type) => {
      state.cooperation_type = cooperation_type
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password)
          .then((response) => {
            const data = response.data
            setToken(data.token, userInfo.keepLogin)
            commit('SET_TOKEN', data.token)
            commit('SET_ID', data.user.id)
            commit('SET_NAME', data.user.username)
            commit('SET_FULL_NAME', data.user.full_name)
            commit('SET_USER_NAME', data.user.name)
            commit('SET_IS_OPEN_COMPANY', data.user.is_open_company)
            commit('SET_IS_SELF_USE', data.user.is_self_use)
            commit('SET_IS_SHOW_COST', data.user.is_show_cost)
            commit('SET_COOPERATION_TYPE', data.user.cooperation_type)
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getInfo(state.token)
          .then((response) => {
            const data = response.data
            if (!data.permissions || data.permissions.length == 0) {
              data.permissions = ['admin']
            }

            if (data.permissions && data.permissions.length > 0) {
              // 验证返回的roles是否是一个非空数组
              commit('SET_ID', data.user.id)
              commit('SET_NAME', data.user.username)
              commit('SET_FULL_NAME', data.user.full_name)
              commit('SET_USER_NAME', data.user.name)
              commit('SET_PERMISSIONS', data.permissions)
              commit('SET_IS_OPEN_COMPANY', data.user.is_open_company)
              commit('SET_IS_SELF_USE', data.user.is_self_use)
              commit('SET_IS_SHOW_COST', data.user.is_show_cost)
              commit('SET_COOPERATION_TYPE', data.user.cooperation_type)
            } else {
              reject('抱歉，您无权限访问')
            }
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 登出
    // LogOut({ commit, state }) {
    //   return new Promise((resolve, reject) => {
    //     logout(state.token).then(() => {
    //       commit('SET_TOKEN', '')
    //       commit('SET_ROLES', [])
    //       removeToken()
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_PERMISSIONS', [])
        removeToken()
        resolve()
      })
    },
  },
}

export default user
